import { default as Block, classForType } from '@intercom/embercom-composer/blocks/types/base/block';
import BlockRange from '@intercom/embercom-composer/blocks/block-range';
import BlockMutationResult from '@intercom/embercom-composer/blocks/block-mutation-result';
import intermoji from '@intercom/intermoji';
import { hasNativeEmojiSupport } from '@intercom/embercom-composer/lib/intermoji';
import Em from 'ember';
function stringInsert(text, index, textToInsert) {
  //TODO: GJ: extract
  return text.slice(0, index) + textToInsert + text.slice(index);
}
export default Block.extend({
  allowedEntities: ['bold', 'italic', 'anchor', 'attribute', 'mention', 'marker', 'code'],
  wordDelimiters: [' ', '/', '-', '\n'],
  isTextType: true,
  canSplit: true,
  inlineReplacements: [],
  blockReplacements: [],
  doInlineReplacements(mutationResult) {
    this.get('inlineReplacements').forEach(function (Replacement) {
      Replacement.tryReplacement(this, mutationResult);
    }.bind(this));
  },
  doInlineReplacementsWithIndex(index) {
    this.get('inlineReplacements').forEach(function (Replacement) {
      Replacement.tryReplacementWithIndex(this, index);
    }.bind(this));
  },
  doBlockReplacements(mutationResult) {
    this.get('blockReplacements').forEach(function (Replacement) {
      Replacement.tryReplacement(this, mutationResult);
    }.bind(this));
  },
  serialized: Em.computed('serializedInnerHtml', function () {
    let serializedInnerHtml = this.get('serializedInnerHtml');
    if (this.get('config.allowEmoji') && !hasNativeEmojiSupport()) {
      serializedInnerHtml = intermoji.substituteUnicodeForColonified(serializedInnerHtml);
    }
    return {
      type: this.get('type'),
      text: serializedInnerHtml
    };
  }),
  insertCharacter(blockRange, options) {
    options = options || {};
    let text = this.get('text');
    let length = text.length;
    let entities = this.get('entities');
    let index = blockRange.get('startPoint.positionIndex');
    let character = options.character;
    let lengthDiff = 1;
    text = stringInsert(text, index, character);
    lengthDiff = text.length - length;
    this._checkIndexIsInRange(index, length, 'insertCharacter');
    let entitesAfter = entities.afterRange(blockRange);
    let entitesAtIndex = entities.atIndex(index);
    entitesAfter.forEach(function (entity) {
      entity.shiftRightBy(lengthDiff);
    });
    entitesAtIndex.forEach(function (entity) {
      let type = entity.get('type');
      let startIndex = entity.get('startIndex');
      let endIndex = entity.get('endIndex');
      if (type === 'bold' && options.skipBold) {
        return;
      }
      if (type === 'italic' && options.skipItalic) {
        return;
      }
      if (type === 'anchor' && endIndex === index) {
        return;
      }
      if (type === 'anchor' && entity.get('startIndex') === index || type === 'mention' && entity.get('startIndex') === index) {
        entity.shiftRightBy(lengthDiff);
        return;
      }
      if (type === 'mention' && endIndex === index) {
        return;
      }
      if (type === 'marker' && endIndex === index) {
        return;
      }
      if (type === 'attribute' && endIndex === index) {
        return;
      }
      if (type === 'code' && endIndex === index) {
        return;
      }
      if (type === 'attribute' && startIndex === index) {
        entity.shiftRightBy(lengthDiff);
        return;
      }
      if (entity.get('type') === 'mention') {
        this.get('entities').removeObject(entity);
      }
      entity.expandToRightBy(lengthDiff);
    }, this);
    this.set('text', text);
    let mutationResult = BlockMutationResult.create({
      blockRange: BlockRange.atPositionIndex(index + lengthDiff)
    });
    this.doBlockReplacements(mutationResult);
    this.doInlineReplacements(mutationResult);
    return mutationResult;
  },
  backspaceWord(blockRange) {
    let text = this.get('text');
    let endIndex = blockRange.get('startPoint.positionIndex');
    let startIndex = endIndex;
    if (endIndex === 0) {
      return BlockMutationResult.create({
        blockRange
      });
    }
    let wordDelimiters = this.get('wordDelimiters');
    let charIsDelimiter, hasFoundWord;
    for (startIndex; startIndex > 0; startIndex--) {
      charIsDelimiter = wordDelimiters.includes(text[startIndex - 1]);
      if (hasFoundWord && charIsDelimiter) {
        break;
      }
      if (!charIsDelimiter) {
        hasFoundWord = true;
      }
    }
    let newBlockRange = BlockRange.atPositionIndex(startIndex, endIndex);
    return this.delete(newBlockRange);
  },
  deleteWord(blockRange) {
    let text = this.get('text');
    let startIndex = blockRange.get('startPoint.positionIndex');
    let endIndex = startIndex;
    if (startIndex === text.length) {
      return BlockMutationResult.create({
        blockRange
      });
    }
    let wordDelimiters = this.get('wordDelimiters');
    let charIsDelimiter, hasFoundWord;
    for (endIndex; endIndex < text.length; endIndex++) {
      charIsDelimiter = wordDelimiters.includes(text[endIndex]);
      if (hasFoundWord && charIsDelimiter) {
        break;
      }
      if (!charIsDelimiter) {
        hasFoundWord = true;
      }
    }
    let newBlockRange = BlockRange.atPositionIndex(startIndex, endIndex);
    return this.delete(newBlockRange);
  },
  insert(block, caretIndex) {
    let right, middle, left;
    if (block.get('isTextType')) {
      left = this;
      middle = block;
      if (caretIndex < this.get('text.length')) {
        right = this.split(BlockRange.atPositionIndex(caretIndex));
      }
      left.join(middle);
      if (right) {
        left.join(right);
      }
      return BlockMutationResult.create({
        blockRange: BlockRange.atPositionIndex(caretIndex + block.get('text').length)
      });
    } else {
      throw new Error('Inserting a non-text type block into a block is not currently supported');
    }
  },
  split(blockRange) {
    if (blockRange.get('hasLength')) {
      throw new Error('Cannot split using a blockRange with a width');
    }
    let startIndex = blockRange.get('startPoint.positionIndex');
    let endIndex = blockRange.get('endPoint.positionIndex');
    let text = this.get('text');
    let left = text.slice(0, startIndex);
    let right = text.slice(endIndex);
    let newBlock = classForType(this.get('splitType')).create({
      config: this.get('config')
    });
    newBlock.set('text', right);
    newBlock.set('align', this.get('align') || 'left');
    this._copyEntitiesForSplit(newBlock, startIndex);
    this.set('text', left);
    this._updateEntitiesForDelete(BlockRange.atPositionIndex(startIndex, text.length));
    return newBlock;
  },
  join(block) {
    if (block.get('isListType')) {
      return this._joinWithList(block);
    }
    if (block.get('isCodeBlock')) {
      return this._joinWithCode(block);
    }
    return BlockMutationResult.create({
      blocksToRemove: [block]
    });
  },
  _joinWithList(block, includeEntities = true) {
    let blocksToRemove;
    let firstListItem = block.get('blockList').shiftObject();
    let text = this.get('text');
    if (includeEntities) {
      this.set('entities', this._joinEntitiesFromRight(firstListItem));
    }
    this.set('text', text + firstListItem.get('text'));
    if (block.get('isEmpty')) {
      blocksToRemove = [block];
    }
    return BlockMutationResult.create({
      blockRange: BlockRange.atPositionIndex(text.length),
      blocksToRemove
    });
  },
  _joinWithCode(block) {
    let blocksToRemove = [];
    let text = this.get('text');
    this.set('text', text + block.get('text'));
    blocksToRemove.pushObject(block);
    return BlockMutationResult.create({
      blocksToRemove,
      blockRange: BlockRange.atPositionIndex(text.length)
    });
  },
  updateText(text) {
    let mutationResult = BlockMutationResult.create();
    this.set('text', text);
    this.doBlockReplacements(mutationResult);
    return mutationResult;
  },
  _copyEntitiesForSplit(newBlock, splitPoint) {
    let text = this.get('text');
    let blockRange = BlockRange.atPositionIndex(splitPoint + 1, text.length + 1);
    let contractBy;
    this.get('entities').removeObjects(this.get('entities').byTypeWithinRange('mention', blockRange));
    let copiedEntities = this.get('entities').withinRange(blockRange).map(function (entity) {
      let newEntity = entity.copy();
      contractBy = splitPoint - newEntity.get('startIndex');
      if (contractBy > 0) {
        newEntity.contractFromLeftBy(contractBy);
      }
      newEntity.shiftLeftBy(splitPoint);
      return newEntity;
    });
    newBlock.get('entities').pushObjects(copiedEntities);
  },
  _joinEntitiesFromRight(block, allowedTypes) {
    let newEntities = this.get('entities');
    block.get('entities').shiftRightBy(this.get('text.length'));
    if (allowedTypes) {
      newEntities.addObjects(block.get('entities').filter(function (entity) {
        return allowedTypes.includes(entity.get('type'));
      }));
    } else {
      newEntities.addObjects(block.get('entities'));
    }
    newEntities.mergeAll();
    return newEntities;
  }
});